<template>
  <hr class="my-6 -mx-6 border-t border-gray-100">
</template>

<script>
export default {
  name: 'Divider'
}
</script>
